module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-6-45bdc3fb79b83bac2782c506263dc6b4.jpeg";